export default "__VITE_ASSET__GWy5wNg3__"